export default "__VITE_ASSET__Hivz0hw3__"